import { render, staticRenderFns } from "./StudioUpdatePage.vue?vue&type=template&id=7dea5b17&scoped=true"
import script from "./StudioUpdatePage.vue?vue&type=script&lang=js"
export * from "./StudioUpdatePage.vue?vue&type=script&lang=js"
import style0 from "./StudioUpdatePage.vue?vue&type=style&index=0&id=7dea5b17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dea5b17",
  null
  
)

export default component.exports